export type Project = {
  name: string
  category: string
  kind: 'LIVE PROJECT' | 'CONCEPT PROJECT'
  desktop: string
  mobile?: string
  accent: string
}

export const projects: Project[] = [
  {
    name: 'FLATBED DRIVER JOBS',
    category: 'RECRUITMENT / LOGISTICS',
    kind: 'LIVE PROJECT',
    desktop: '/assets/truck-flatbed-live.png',
    accent: '#c34836',
  },
  {
    name: 'BALLOONISH',
    category: 'EVENTS / CELEBRATION',
    kind: 'CONCEPT PROJECT',
    desktop: '/assets/balloonish-desktop.png',
    mobile: '/assets/balloonish-mobile.png',
    accent: '#3856cc',
  },
  {
    name: "BOUQUETS BY NORY'S",
    category: 'FLORAL / E-COMMERCE',
    kind: 'CONCEPT PROJECT',
    desktop: '/assets/bouquets-desktop.png',
    mobile: '/assets/bouquets-mobile.png',
    accent: '#9d654b',
  },
  {
    name: 'PROPERTY WASHING PROS',
    category: 'LOCAL SERVICE / LEADS',
    kind: 'CONCEPT PROJECT',
    desktop: '/assets/property-washing-desktop.png',
    mobile: '/assets/property-washing-mobile.png',
    accent: '#187779',
  },
  {
    name: 'JERSEY RINSE',
    category: 'MOBILE DETAILING',
    kind: 'CONCEPT PROJECT',
    desktop: '/assets/jersey-rinse-desktop.png',
    mobile: '/assets/jersey-rinse-mobile.png',
    accent: '#52bea5',
  },
]
